import * as React from "react";
import {getAcknowledgement,getUser} from "../polar-SAAS-Components/api-helper";
import useStyleClasses from "../polar-SAAS-Components/style";

const AcknowledgementViewPopup = ({ onClose, emailAckId,notification }) => {
  const classes = useLocalStyles();
  const styleClasses=useStyleClasses();

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const [details, setDetails] = React.useState({
    name: "",
    kitId: "",
    message: "",
    status: "",
    email: "",
    userName: "",
    endTime: ""
  });

  React.useEffect(() => {
    if (emailAckId) {
      fetchNotificationDetails();
    }
  }, [emailAckId]);

  const fetchNotificationDetails = async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await getAcknowledgement(emailAckId);
      console.log("Acknowledgement Response:", res);

      if (res.status !== 200) throw new Error("API failed");

      const notificationAck = await res.data.content;

      const userDetails= await getUser(notificationAck.userId);
      console.log("User Details Response:", userDetails);
      if (userDetails.status !== 200) throw new Error("User API failed");
      const userData= await userDetails.data.content;


      setDetails({
        name: notificationAck.name ,
        kitId: notificationAck.kitId,
        message: notificationAck.message,
        status: notificationAck.status,
        email: notificationAck.email,
        userName: userData && userData.username ? userData.username : "N/A",
        endTime: notificationAck.endTime ?notificationAck.endTime :"N/A"
      });
    } catch (err) {
      setError("Failed to fetch notification details");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="model-overlay" >
      <div className="model" style={classes.modelStyle}>
      {/* Header */}
      <div style={classes.header}>
        <h3 style={classes.headerTitle}>Acknowledgement Status</h3>
        <span style={classes.closeBtn} onClick={onClose}>✖</span>
      </div>

      {loading && <p style={classes.infoText}>Loading...</p>}
      {error && <p style={classes.errorText}>{error}</p>}

      {!loading && !error && (
        <>
          <Section classes={classes} title="Kit Alert Details">
            <Info classes={classes} label="Kit Name" value={details.kitId} />
            <Divider classes={classes} />
            <Info classes={classes} label="notification" value={notification.message} />
            </Section>
             <hr style={classes.hr} />
            <Section classes={classes} title="Acknowlowedgement Details">
            <Info classes={classes} label="User Name" value={details.userName} />
            <Divider classes={classes} />
            <Info classes={classes} label="Time" value={details.endTime} />
          </Section>

          <hr style={classes.hr} />

          <div style={classes.section}>
            <p style={classes.label}>Selected Action</p>
            <p style={classes.value}>{details.status}</p>
          </div>

          <hr style={classes.hr} />

          <div style={classes.section}>
            <p style={classes.label}>Message from Acknowledged Person</p>
            <p style={classes.value}>{details.message}</p>
          </div>
        </>
      )}
    </div>
    </div>
  );
};

/* ---------- Small Reusable Blocks ---------- */

const Section = ({ title, children, classes }) => (
  <div style={classes.section}>
    <h4 style={classes.sectionTitle}>{title}</h4>
    <div style={classes.row}>{children}</div>
  </div>
);

const Info = ({ label, value, classes }) => (
  <div style={classes.infoBox}>
    <p style={classes.label}>{label}</p>
    <p style={classes.value}>{value}</p>
  </div>
);

const Divider = ({ classes }) => <div style={classes.divider} />;

export default AcknowledgementViewPopup;



const useLocalStyles =()=>{
  return({
  modelStyle: {
    padding: 10,
    borderRadius:5

  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 15,
    margin: -10
  },
  headerTitle: {
    margin: 0,
    fontSize: 16,
    fontWeight: 400,
    color: "#010101ff"
  },
  closeBtn: {
    cursor: "pointer",
    fontSize: 16,
    color: "#626262ff",
  },
  section: {
    marginLeft: 10,
    marginTop: 10
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#2A7BEC",
    marginBottom: 10
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    gap: 15
  },
  infoBox: {
    flex: 1,
    minWidth: 120
  },
  label: {
    fontSize: 14,
    color: "#777",
    margin: 0
  },
  value: {
    fontSize: 12,
    fontWeight: 500,
    color: "#333",
    marginTop: 8
  },
  divider: {
    width: 1,
    backgroundColor: "#ccc"
  },
  hr: {
    border: "none",
    borderTop: "1px solid #ccc",
    margin: "5px 0"
  },
  infoText: {
    padding: 10,
    color: "#2A7BEC"
  },
  errorText: {
    padding: 10,
    color: "red"
  }
})};
